import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { Account } from "../../../_app/types";
import { Box, Modal } from "@mui/material";
import AccountsList from "../../AccountsList/AccountsList";
import { ButtonStyled } from "../../../_components/ButtonStyled";
import IconComponent from "../../../components/ui/IconComponent";
import { useTranslation } from "react-i18next";
import Text from "../../../_components/Text";

interface AccountPopupProps {
  open: boolean;
  onClose: (value: boolean) => void;
  accounts: Account[];
  activeAccount: string;
  onChangeAccount: (value: Account) => void;
}

const AccountPopup = ({
  open,
  onClose,
  accounts,
  onChangeAccount,
  activeAccount,
}: AccountPopupProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation("account");

  const handleClose = () => onClose(false);

  const viewMarketList = () => {
    onClose(true);
    navigate("/account/add");
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          sx: {
            top: "56px",
          },
        },
      }}
      sx={{
        overflow: "hidden",
        top: "56px",
        height: "calc(100% - 78px)",
        paddingX: "8px",
        zIndex: 2000,
      }}
    >
      <Box
        sx={{
          padding: "16px 8px 16px",
          borderRadius: "8px",
          backgroundColor:
            theme.palette.mode === "dark" ? "rgba(29, 30, 32, 1)" : "rgba(228, 228, 228, 1)",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          boxSizing: "border-box",
        }}
        color={theme.palette.grey[500]}
      >
        <Box sx={{ flexShrink: 0 }}>
          <Text mb="24px" ml="16px" variant="regular-semi">
            Accounts
          </Text>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              flex: 1,
            }}
          >
            <AccountsList
              accounts={accounts}
              activeAccount={activeAccount}
              onChangeAccount={onChangeAccount}
            />
          </Box>

          <ButtonStyled
            onClick={viewMarketList}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 16px",
              marginTop: "16px",
            }}
            fullWidth={true}
            color={"secondary"}
            variant="contained"
            endIcon={<IconComponent iconName={"Plus"} hasFill hasStroke />}
          >
            {t("connectAccount")}
          </ButtonStyled>
        </Box>
      </Box>
    </Modal>
  );
};

export default AccountPopup;
